import React from 'react';
import {Image as RNImage, View, Animated} from 'react-native';
import {useImageSettings, useImageSize} from './helpers';
import {IOwnProps} from './model';

export const Image = (props: IOwnProps) => {
  const {important, animated, style, animatedImageStyle, ...rnProps} = props;
  const {offColor, hideImage} = useImageSettings(important);
  const {handleLayout, width, height} = useImageSize();

  const offColorStyle = {filter: 'grayscale(1)'} as any;

  if (hideImage && width && height) {
    return <View style={[style, {width, height}]} />;
  }

  const Component = animated ? Animated.Image : RNImage;

  return (
    <Component
      onLayout={handleLayout}
      resizeMode='contain'
      style={[
        {width: props.width, height: props.height},
        style,
        animated ? animatedImageStyle : {},
        offColor && offColorStyle,
      ]}
      {...rnProps}
    />
  );
};
